module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti-b3aaa0b871336be886736a9615ef1151.webp";